import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Add this import
import { Dropdown } from "react-bootstrap";

import PageBanner from "../layouts/PageBanner";
import ProjectMasonry from "../components/Project/ProjectMasonry";
import UpdateBlog from "../components/Home/UpdateBlog";

import bg from "../assets/images/banner/bnr5.jpg";
import { donate, getAllProjects } from "../apis/Projects";
import { AppContext } from "../context/AppContext";
import DonateModal from "../components/Modal/DonateModal";

const Project = () => {
  const [dropbtn2, setDropbtn2] = useState("All Category");

  const { handleLogOut, setUser, user } = useContext(AppContext);

  const [projects, setProjects] = useState(null);
  const [meta, setMeta] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // Add this line

  useEffect(() => {
    fetchProjects();
  }, [currentPage]);

  const handlePageClick = async (data) => {
    setCurrentPage(data.selected + 1);
  };

  const fetchProjects = async () => {
    setLoading(true);
    try {
      let { data } = await getAllProjects(currentPage);

      setProjects(data.results);
      //   setMeta(data.meta);
    } catch (error) {
      if (error.response?.status === 401) {
        handleLogOut();
      } else {
        setProjects([]);
        console.log(error);
      }
    }
    setLoading(false);
  };

  const handleCreateProject = () => {
    const currentDate = new Date();
    const cutoffDate = new Date(currentDate.getFullYear(), 0, 29);

    if (currentDate > cutoffDate) {
      alert(
        "Project creation is currently paused until the second round. Stay tuned for updates and get ready to bring your ideas to life soon!"
      );
    } else {
      navigate("/create-project");
    }
  };

  if (!projects) return <h1>Loading ...</h1>;

  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="All Projects" background={bg} />
        <div className="find-bx-wrapper">
          <div className="container">
            <div className="find-bx bg-white">
              <form>
                <div className="row align-items-center">
                  <div className="col-lg-3 col-md-4">
                    <div className="">
                      <Dropdown className="select-drop-2">
                        <Dropdown.Toggle
                          as="div"
                          className="i-false select-drop-btn-2"
                        >
                          <span>{dropbtn2}</span>
                          <i className="fa-regular fa-angle-down"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => setDropbtn2("All Category")}
                          >
                            All Category
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setDropbtn2("Newest")}>
                            Newest
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setDropbtn2("Oldest")}>
                            Oldest
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-8">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Find Projects"
                      />
                      <div className="input-group-prepend">
                        <button className="btn">
                          <i className="las la-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="tag-list">
              <span className="title text-black">Popular Search:</span>
              <Link to={"#"}>Energy,</Link>
              <Link to={"#"}>Education,</Link>
              <Link to={"#"}>Technology,</Link>
              <Link to={"#"}>Health</Link>
            </div>
          </div>
        </div>
        <section className="content-inner-2">
          <div className="container mb-5">
            {" "}
            {/* Add mb-5 class for bottom margin */}
            <div className="d-flex justify-content-end mb-4 mt-2">
              <button className="btn btn-primary" onClick={handleCreateProject}>
                Create Project
              </button>
            </div>
            <ProjectMasonry user={user} projects={projects} />
          </div>
        </section>
        {/* <div className="call-action style-1 content-inner-1">
          <div className="container">
            <UpdateBlog />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Project;
